import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
const Testimonials = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(data);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData1 = await getPrincipalMessage();
        const principalData = principalData1.filter((item) => item.category === "Principal");
        console.log("Get Principal MESSAGE", principalData)
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  const emptyData = [
    {
      category: "Principal",
      title: "Principal Message",
      name: "Fr. John Marcus Fernandes",
      designation: (
        <>Fr. John Marcus Fernandes  <br /> Principal </>
      ),
      message: (
        <></>
      ),

      image:
        "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/principal-25.jpg",
      link: "/",
    },
  ];
  return (
    <>
      {data && data.length > 0 ? data.map((item, index) => (
        <div className="message-container" key={index}>
          <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/message.gif" className="img-fluid msg-icon" />
          <div className="maintitle">
            <h3 className="text-center">Principal's Message</h3>
          </div>
          <div className="messageimg">
            <div className="testimonialimg">
              <LazyLoad><img src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments}`} alt="Mata Mariyam Jan Sewa" className="img-fluid" /></LazyLoad>
            </div>
            <div className="messageboximg">
              <p>{item.name} <span>{item.category}</span>{" "}
              </p>
            </div>
          </div>
          <div className="messagebox">
            <div className="messagedesc">
              {/* <p><div dangerouslySetInnerHTML={{ __html: item.message }} /></p> */}
              <p> <div>Warm greetings to all students, parents, teachers, and well-wishers of our school community.<br />
                It gives me immense joy to welcome you to our school website a window into the life, values, and aspirations of our institution. At the heart of our educational journey lies our <b>Motto: Solidarity of All Religions.</b> We firmly believe that true education nurtures respect, harmony, and unity among all people. By fostering an environment where every faith and culture is respected, we strive to build a campus enriched with peace, understanding, and mutual acceptance.</div></p>
            </div>
            <div className="arrow-button">
              <Link to="/principal"><i className="bi bi-arrow-right"></i></Link>
            </div>
          </div>
        </div>
      )) : emptyData.map((data) => (
        <div className="message-container">
          <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/message.gif" className="img-fluid msg-icon" />
          <div className="maintitle">
            <h3 className="text-center">Principal's Message</h3>
          </div>
          <div className="messageimg">
            <div className="testimonialimg">
              <LazyLoad><img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/principal-25.jpg" alt="Mata Mariyam Jan Sewa" className="img-fluid" /></LazyLoad>
            </div>
            <div className="messageboximg">
              <p>Fr. John Marcus Fernandes <span> principal</span>{" "}</p>
            </div>
          </div>
          <div className="messagebox">
            <div className="messagedesc">
              <p>It is an honor to be the principal of MMJSV. An illustrious heritage institution as it stands today is what it is because of the collaboration and passion of the Management, Teachers, Parents & Students down the ages. Therefore, let us continue to work together with passion as pilgrims of faith by putting all our energies together for one common goal: to inculcate compassion and care in our society, in view of shaping individuals who are responsible for themselves and for others, individuals who will care for all creatures and the earth. </p>
            </div>
            <div className="arrow-button">
              <Link to="/principal"><i className="bi bi-arrow-right"></i></Link>
            </div>
          </div>
        </div>
      ))
      }
    </>
  );
};

export default Testimonials;
